import { Ban, FileText, PackageCheck, Truck } from 'lucide-react'
import { type ReactNode } from 'react'

import type { PurchaseSummary } from '@aeris/contracts'
import {
  PURCHASE_STATUS_TEXT,
  type PurchaseStatusText,
} from '@aeris/status-meta'
import { type StatusTone } from '@aeris/ui'

/**
 * O que cada situação de uma compra QUER DIZER — F156.
 *
 * Mesmo molde de `sales-status-meta.tsx`, e pela mesma razão: rótulo, cor,
 * ícone e a frase que explica moram juntos, e as quatro superfícies (selo,
 * legenda, ficha, glossário) leem daqui.
 *
 * **Só constantes, nenhum componente** — Fast Refresh.
 */

type Status = PurchaseSummary['status']

export type PurchaseStatusMeta = Omit<PurchaseStatusText, 'tone'> & {
  readonly tone: StatusTone
  readonly icon: ReactNode
}

const icon = (Glyph: typeof Truck): ReactNode => (
  <Glyph aria-hidden="true" className="h-3 w-3" />
)

// O texto mora em `@aeris/status-meta` (F305); aqui só entra o ícone.
export const PURCHASE_STATUS_META: Readonly<
  Record<Status, PurchaseStatusMeta>
> = {
  draft: { ...PURCHASE_STATUS_TEXT.draft, icon: icon(FileText) },
  confirmed: { ...PURCHASE_STATUS_TEXT.confirmed, icon: icon(Truck) },
  received: { ...PURCHASE_STATUS_TEXT.received, icon: icon(PackageCheck) },
  cancelled: { ...PURCHASE_STATUS_TEXT.cancelled, icon: icon(Ban) },
}

export const PURCHASE_LEGEND = [
  PURCHASE_STATUS_META.draft,
  PURCHASE_STATUS_META.confirmed,
  PURCHASE_STATUS_META.received,
  PURCHASE_STATUS_META.cancelled,
] as const
